// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductDocumentService = {};

ProductDocumentService.getProductDocumentList = function (data) {
  return lossClient({
    url: "/producttype",
    method: "get",
    data: data,
  });
};

ProductDocumentService.getProductDocumentDetail = function (data) {
  return lossClient({
    url: `/producttype/${data}`,
    method: "get",
  });
};

ProductDocumentService.postProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/add`,
    method: "post",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductId: data.id,
      ProductDocuments: data.ProductDocuments,
      UserId: "Ilham",
    },
  });
};

ProductDocumentService.updateProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/edit`,
    method: "put",
    headers: {
      "X-RequestId": data.id,
    },
    data: {
      ProductId: data.id,
      ProductDocuments: data.ProductDocuments,
      UserId: "Ilham",
    },
  });
};

ProductDocumentService.deleteProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/Delete`,
    method: "delete",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductId: data.id,
      ProductDocuments: data.ProductDocuments,
      UserId: "Ilham",
    },
  });
};

ProductDocumentService.returnProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/Return`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductId: data.id,
      ProductDocuments: data.ProductDocuments,
      UserId: "Ilham",
    },
  });
};

ProductDocumentService.approveProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/approve`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductId: data.id,
      ProductDocuments: data.ProductDocuments,
      UserId: "Ilham",
    },
  });
};

ProductDocumentService.rejectProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/reject`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductDocuments: data.ProductDocuments,
      userid: "Ilham",
    },
  });
};

ProductDocumentService.requestProductDocument = function (data) {
  return lossClient({
    url: `/ProductDocument/request`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: {
      ProductDocuments: data.ProductDocuments,
      Request: data.Request,
      Note: data.Note,
      userid: "Ilham",
    },
  });
};

export default ProductDocumentService;
